import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';

type Status = {
  min_char?: boolean;
  one_digit?: boolean;
  one_special_char?: boolean;
  one_uppercase?: boolean;
  one_lowercase?: boolean;
};

type Props = { status: Status };

function HintItem({
  ok,
  label,
}: {
  ok: boolean | undefined;
  label: string;
}) {
  return (
    <li className="flex items-center gap-2 py-0.5">
      {ok === true ? (
        <Check className="h-4 w-4 text-green-600" />
      ) : ok === false ? (
        <X className="h-4 w-4 text-destructive" />
      ) : (
        <span className="h-4 w-4 text-muted-foreground">-</span>
      )}
      <span className="text-xs">{label}</span>
    </li>
  );
}

export default function Hint({ status }: Props) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
      <ul className="space-y-0">
        <HintItem ok={status.min_char} label={t('REGISTRATION.8_CHARACTERS_MINIMUM')} />
        <HintItem ok={status.one_digit} label={t('REGISTRATION.ONE_DIGIT')} />
      </ul>
      <ul className="space-y-0">
        <HintItem
          ok={status.one_special_char}
          label={t('REGISTRATION.ONE_SPECIAL_CHARACTER')}
        />
        <HintItem ok={status.one_uppercase} label={t('REGISTRATION.ONE_UPPERCASE')} />
        <HintItem ok={status.one_lowercase} label={t('REGISTRATION.ONE_LOWERCASE')} />
      </ul>
    </div>
  );
}
